import React, { useEffect, useState } from "react";
import CardLayoutOne from "../../components/cards/CardLayoutOne";
import { t } from "i18next";
import MainButton from "../../components/buttons/MainButton";
import { useNavigate } from "react-router-dom";
import { codeStatusRequest } from "../../core/subscription/request";
import Snackbar, { SnackbarType } from "../../components/snackbar/Snackbar";


const Medium = () => {
  const navigate = useNavigate();
  const products = [
    {
      id: 30,
      name: `${t("twintreeplus.head")} 2x`,
      description:
       `${t("twintreeplus.description")}`,
      price: "66",
      image:
        "https://gardenof.life/storage/images/bali/JwEp1ikI1riCycdDALml44H8z.png",
      link: "/subscription/purchase",
      is_subscribed: true,
      quantity: 2,
    },
    {
      id: 4,
      name: `${t("treenft.head")} 1x`,
      description:
        `${t("treenft.description")}`,
      price: "55",
      image:
        "https://gardenof.life/storage/images/brazil/TsRCFyiBHciN6L8wtqKYWoEcm.png",
      link: "/subscription/purchase",
      is_subscribed: true,
      quantity: 1,
    },
    {
      id: 25,
      name: `${t("compassion.head")} 1x`,
      description:
      `${t("compassion.description")}`,
      price: "55",
      image:
        "https://gardenof.life/assets/images/compassion-card/compassion-card.png",
      link: "/subscription/purchase",
      is_subscribed: true,
      quantity: 1,
    },
    {
      id: 8,
      name: `${t("endarged.head")} 2x`,
      description:
      `${t("endarged.description")}`,
      price: "66",
      image:
        "https://gardenof.life/storage/images/botswana/na48cTEFroTcLryo3wiBmicVC.png",
      link: "/subscription/purchase",
      is_subscribed: true,
      quantity: 2,
    },
  ];
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
    () => {
      const savedId = localStorage.getItem("selectedProductId");
      return savedId ? parseInt(savedId, 10) : null;
    }
  );

  const handleSelect = (id: number, isChecked: boolean) => {
    if (isChecked) {
      setSelectedProductId(id);
      localStorage.setItem("selectedProductId", id.toString());
    } else {
      setSelectedProductId(null);
      localStorage.removeItem("selectedProductId");
    }
  };

  const handleClick = () => {
    if (selectedProductId) {
      const selectedProduct = products.find(
        (product) => product.id === selectedProductId
      );
      const subscriptionLinkCode =
        new URL(window.location.href).searchParams.get("code") || "defaultCode";
      localStorage.setItem("selectedProduct", JSON.stringify(selectedProduct));
      localStorage.setItem("subscriptionLinkCode", subscriptionLinkCode);
      navigate("/checkout");
    }
  };

  const [snackbarState, setSnackbarState] = useState<{
    show: boolean;
    message: string;
    type: SnackbarType;
  }>({
    show: false,
    message: "",
    type: "error", // Default type
  });

  const [isBuyButtonDisabled, setIsBuyButtonDisabled] = useState(false);

  // Function to show the snackbar
  const showSnackbar = (message: string, type: SnackbarType) => {
    setSnackbarState({ show: true, message, type });
  };

  // Function to hide the snackbar
  const hideSnackbar = () => {
    setSnackbarState((prevState) => ({ ...prevState, show: false }));
  };

  const codeStatus = async () => {
    const subscriptionLinkCode =
      new URL(window.location.href).searchParams.get("code") || "defaultCode";

    try {
      const paymentData = {
        // subscription: true,
        subscription_link_code: subscriptionLinkCode,
      };

      const response = await codeStatusRequest(paymentData);
      if (response.data.status == "error") {
        setIsBuyButtonDisabled(true);
        showSnackbar(
          "This product purchase link against Subscription is already Consumed",
          "error"
        );
      } else {
        setIsBuyButtonDisabled(false);
      }
    } catch (error) {
      console.error("Wrong Code:", error);
    }
  };
  useEffect(() => {
    codeStatus();
  }, []);

  window.addEventListener("unload", (event) => {
    codeStatus();
    console.log("API call after page reload");
  });

  return (
    <>
      <section className="pb-5 subscription-sec">
        <div className="container">
          <div className="subscription-head-sec text-center">
            <h1 className="mb-3">{t("mid.heading")} {t("plan")}</h1>
            <h6 className="mb-3">{t("product.subhead")}</h6>
          </div>
          <div className="row mt-5">
            {products.map((item, index) => (
              <CardLayoutOne
                key={index}
                btnText={t("buttons.buyNow")}
                btnFullWidth={""}
                colClass={"col-lg-3 col-md-6"}
                shadow={true}
                title={item.name}
                bgColor={"three"}
                image={item.image}
                titleClass={"f-title-bold"}
                imageClass={"h-200"}
                price={item.price}
                description={item.description}
                is_subscribed={item.is_subscribed}
                id={item.id}
                disabled={
                  selectedProductId !== null && selectedProductId !== item.id
                }
                onSelect={handleSelect}
                isChecked={selectedProductId === item.id}
              />
            ))}
          </div>

          <div className="text-center">
            <MainButton
              onClick={handleClick}
              className={`btn btn-primary-dark ps-lg-5 pe-lg-5 ps-3 pe-3`}
              text="Buy Now"
              withLogo={false}
              disabled={selectedProductId === null || isBuyButtonDisabled == true}
            />
          </div>
        </div>
      </section>

      <Snackbar
        message={snackbarState.message}
        type={snackbarState.type}
        show={snackbarState.show}
        onClose={hideSnackbar}
        duration={9000}
      />
    </>
  );
};

export default Medium;
